import React, { useState, useEffect } from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.jpg';

const ADMIN_LINKS = [
  { section: 'Overview', items: [
    { to: '/admin', label: 'Dashboard', end: true },
    { to: '/admin/reports', label: 'Reports & Analytics' },
  ]},
  { section: 'Exam Setup', items: [
    { to: '/admin/questions', label: 'Questions' },
    { to: '/admin/papers', label: 'Question Papers' },
    { to: '/admin/departments', label: 'Departments' },
    { to: '/admin/import-export', label: 'Import / Export' },
  ]},
  { section: 'Results', items: [
    { to: '/admin/results', label: 'Results & Review' },
  ]},
  { section: 'Administration', items: [
    { to: '/admin/users', label: 'Users' },
    { to: '/admin/user-activity', label: 'User Activity' },
    { to: '/admin/settings', label: 'Settings' },
    { to: '/admin/audit-log', label: 'Audit Log' },
  ]},
];

const USER_LINKS = [
  { section: '', items: [
    { to: '/', label: 'Home', end: true },
    { to: '/my-results', label: 'My Results' },
  ]},
];

export default function Layout() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const links = isAdmin ? ADMIN_LINKS : USER_LINKS;
  const [navOpen, setNavOpen] = useState(false);

  // Close the mobile drawer whenever the route changes or Escape is pressed.
  useEffect(() => { setNavOpen(false); }, [location.pathname]);
  useEffect(() => {
    if (!navOpen) return;
    const onKey = e => { if (e.key === 'Escape') setNavOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [navOpen]);

  function handleLogout() {
    logout();
    navigate('/login');
  }

  const initials = (user?.name || '?').split(' ').map(p => p[0]).slice(0, 2).join('').toUpperCase();

  return (
    <div className="app-shell">
      <div className={`sidebar-backdrop ${navOpen ? 'show' : ''}`} onClick={() => setNavOpen(false)} aria-hidden="true" />
      <aside className={`sidebar ${navOpen ? 'open' : ''}`}>
        <div className="sidebar-brand">
          <img src={logo} alt="Yashoda Hospitals" className="sidebar-logo" />
          <div className="brand-text">
            <span className="brand-name">Yashoda Hospitals</span>
            <span className="brand-sub">MCQ Analysis</span>
          </div>
          <button className="sidebar-close" onClick={() => setNavOpen(false)} aria-label="Close menu">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              strokeWidth="2" strokeLinecap="round" aria-hidden="true">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        <nav className="sidebar-nav">
          {links.map((group, i) => (
            <div key={i}>
              {group.section && <div className="sidebar-section-label">{group.section}</div>}
              {group.items.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
        <div className="sidebar-foot">
          <button className="btn btn-outline btn-block" style={{ borderColor: 'rgba(255,255,255,0.25)', color: '#e67f38' }} onClick={handleLogout}>
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
            Log out
          </button>
        </div>
      </aside>
      <div className="main-area">
        <header className="topbar">
          <div className="topbar-left">
            <button
              className="hamburger"
              onClick={() => setNavOpen(o => !o)}
              aria-label={navOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={navOpen}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                strokeWidth="2" strokeLinecap="round" aria-hidden="true">
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            </button>
            <div className="topbar-title">
              {isAdmin ? 'Admin Console' : 'Yashoda Hitec City Induction Exam'}
            </div>
          </div>
          <div className="topbar-user">
            <span>{user?.name}</span>
            <div className="avatar">{initials}</div>
          </div>
        </header>
        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
